export default __webpack_public_path__ + "static/media/THSarabunNew.a60f10a0.ttf";